module.exports = "/_next/static/images/sekiya_inside-c83b6acc9a6a03edffc3a73264768ce8.jpg";